// assets/cart-ajax.js
// Intercepteur AJAX add-to-cart — source unique
// Capte : form[action$="/cart/add"] submit + [data-add-to-cart][data-variant-id] click
// Le drawer est géré par son propre JS (events cart:item-added / cart:refresh)
(function () {
  'use strict';

  var isAdding = false;

  function getLiveRegion() {
    return document.getElementById('cd-live-region');
  }

  function announce(msg) {
    var lr = getLiveRegion();
    if (!lr) return;
    lr.textContent = '';
    setTimeout(function () { lr.textContent = msg; }, 50);
  }

  // Toast visible (le catch ne doit jamais échouer en silence pour l'utilisateur voyant)
  var toastTimer = null;
  function showToast(msg) {
    var t = document.getElementById('cd-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4000);
  }

  function reportError(msg) {
    announce(msg);
    showToast(msg);
  }

  function setButtonState(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('disabled', '');
      if (btn.textContent) btn.dataset.cdOrigLabel = btn.textContent.trim();
    } else {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('disabled');
      if (btn.dataset.cdOrigLabel) {
        btn.textContent = btn.dataset.cdOrigLabel;
        delete btn.dataset.cdOrigLabel;
      }
    }
  }

  function addToCart(variantId, qty, btn) {
    if (isAdding) return;
    isAdding = true;
    setButtonState(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }]
      })
    })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || 'Erreur lors de l\'ajout au panier');
        }
        return data;
      });
    })
    .then(function (data) {
      var itemCount = 1;
      if (data.items && data.items.length) {
        itemCount = data.items.reduce(function (acc, item) {
          return acc + item.quantity;
        }, 0);
      }

      // Le drawer JS écoute cart:item-added → openDrawer() → refreshCart()
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        bubbles: true,
        detail: { itemCount: itemCount }
      }));

      announce('Produit ajouté au panier');
    })
    .catch(function (err) {
      reportError(err.message || 'Une erreur est survenue');
    })
    .finally(function () {
      isAdding = false;
      setButtonState(btn, false);
    });
  }

  // Intercepteur délégué : soumission de formulaire /cart/add
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') === null) return;
    if (form.getAttribute('action').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var input = form.querySelector('[name="id"]');
    if (!input || !(Number(input.value) > 0)) return;
    var btn = form.querySelector('[type="submit"]');
    addToCart(input.value, 1, btn);
  });

  // Notification d'erreur émise par un autre composant (ex. cart-drawer changeQty)
  document.addEventListener('cart:notify', function (e) {
    reportError((e.detail && e.detail.msg) || 'Une erreur est survenue');
  });

  // Intercepteur délégué : clic sur [data-add-to-cart][data-variant-id]
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-add-to-cart][data-variant-id]');
    if (!trigger) return;
    var variantId = trigger.getAttribute('data-variant-id');
    if (!variantId) return;
    e.preventDefault();
    addToCart(variantId, 1, trigger);
  });

})();
